import CustomDataTable from 'pages/private/FeedbackEvaluation/tables/CustomDataTable2';
import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import { Cell } from 'react-table';
import { useListRoutineSessionQuestionQuery } from 'redux/reducers/routineFeedback';
interface IRoutineManagementTable {
  tableHeaders?: () => React.ReactNode;
  // status: boolean;
}

const RoutineFeedbackSessionTable: FC<IRoutineManagementTable> = ({ tableHeaders }) => {
  const { id } = useParams();
  const { data: routinefeedbackData, isLoading } = useListRoutineSessionQuestionQuery(id);
  // const mappedData =
  //   routinefeedbackData?.data &&
  //   routinefeedbackData?.data?.length > 0 &&
  //   routinefeedbackData?.data?.filter((item: any, index: number) => {
  //     if (item.feedback_question_details.length !== 0) {
  //       return item.feedback_question_details;
  //     }
  //   });

  // const newMappedData = mappedData?.map(function (item: any) {
  //   return item.feedback_question_details;
  // });
  const columns = [
    {
      Header: 'S.N',
      accessor: 'sn',
      Cell: (cell: Cell) => {
        return cell.row.index + 1;
      }
    },
    {
      Header: 'Feedback in English',
      accessor: 'question'
    },
    {
      Header: 'Feedback in Nepali',
      accessor: 'question_np'
    }
  ];

  return (
    <>
      <div>
        <CustomDataTable
          columns={columns}
          isLoading={isLoading}
          data={
            (!!routinefeedbackData?.data?.length &&
              routinefeedbackData?.data?.[0]?.feedback_question_details) ||
            []
          }
          tableHeaders={tableHeaders}
        />
      </div>
    </>
  );
};

export default RoutineFeedbackSessionTable;
